import { GridInputValue, LayoutInlineForm } from '../../types/types';
import { isEmptyValue } from '../managerUtils';
import { validateLayoutFieldValue } from './validateLayoutFieldValue';

// One definition item against its current value: `mandatory` items must be
// filled; a filled value must pass the field rules (hex colors).
export const validateLayoutItemValue = (
  item: LayoutInlineForm['items'][number],
  value: GridInputValue
): string | null => {
  if (item.mandatory && isEmptyValue(value)) {
    return 'errors.required';
  }

  return item.name ? validateLayoutFieldValue(item.name, value) : null;
};
